import React from 'react';

/** ************* COMPONENTS  ******************** */
import {
    Box,HStack, Tag, Link
} from '@chakra-ui/react';
import BackButton from 'components/Button/BackButton';
import RefreshIcon from 'components/icons/RefreshIcon';
import TabField from 'components/dataDispaly/TabField';
import InviteStatus from 'components/Status/InviteStatus';
/** ******************* helpers  ****************** */
import { useGetBulkInviteDetailsQuery } from 'reducers/realtor.service';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { REALTOR_TYPE } from 'constants/index';
import { viewDateAndTime } from 'utils/date';
import { getAddressString , getStateView } from 'utils/address';

export default function RealtorInvitationDetails() {
    const params = useParams();
    const invitationId = params.id;

    const { data, refetch } = useGetBulkInviteDetailsQuery({ invitationId , USERTYPE: REALTOR_TYPE });
    const company = data?.companyInfo || {};
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                <BackButton />
                <span>Back</span>
                <Box flex={1} textAlign={'end'}>
                    <RefreshIcon handleRefresh={ refetch}/>
                </Box>
            </div>

            <HStack
                width={'100%'}
                gap={'1rem'}
                mb="1rem"
                alignItems={'start'}
                mt={'1rem'}
            >
                <Box flex={1} p={4} borderRadius="lg" boxShadow="md" border="1px solid #E2E8F0" bg="white">
                    <div>
                        <div
                            className="preview-heading"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                                borderBottom: '1px solid #e0e0e0',
                                paddingBottom: '8px'
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    textTransform: 'uppercase',
                                    color: 'black'
                                }}
                            >
                                   Personal Information
                            </p>

                        </div>
                        <div className="preview-body">
                            <div style={{ lineHeight: '2.5rem' }}>
                                <p><strong>Email</strong><br />  <Link href={'mailto:' + data?.Email} color='brand.500'>
                                    {data?.Email}
                                </Link>
                                </p>

                                <p><strong>First Name</strong><br />{data?.FirstName || 'N/A'}</p>
                                <p><strong>Last Name</strong><br />{data?.LastName || 'N/A'}</p>
                                <p><strong>State Licenses</strong><br /></p>

                                {
                                    (data && data?.Statelicenses?.length > 0 && data?.Statelicenses?.map((state,index)=>(
                                        <Tag colorScheme='teal' key={index} m={2} size='md'>{state.label || getStateView(state)}</Tag>
                                    ))) || <TabField value={<p>Doesn&apos;t have any state license</p>}/>
                                }
                                <p><strong>Status</strong><br /></p>

                                <InviteStatus status={data?.invitationStatus || ''}/>

                                <p><strong>Address</strong><br />{getAddressString(data?.Address)}</p>
                                <p><strong>Sent On</strong><br />{viewDateAndTime(data?.createdAt)}</p>

                                <p><strong>Last Updated On</strong><br />{viewDateAndTime(data?.updatedAt)}</p>
                            </div>
                        </div>
                    </div>
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <div>
                        <div
                            className="preview-heading"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                                borderBottom: '1px solid #e0e0e0',
                                paddingBottom: '8px'
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    textTransform: 'uppercase',
                                    color: 'black'
                                }}
                            >
                                   Company Details
                            </p>
                        </div>
                        <div className="preview-body">
                            <div style={{ lineHeight: '2.5rem' }}>
                                <p><strong>Company Email</strong><br />{ <Link href={'mailto:' + company?.companyEmail} color='brand.500'>
                                    {company?.companyEmail}
                                </Link> ||
                                                                                                                    'N/A'}</p>

                                <p><strong>Company Name</strong><br />{company?.companyName}</p>

                                <p><strong>Company Address</strong><br />{getAddressString(company?.Address) || 'N/A'}</p>
                                <p><strong>Updated At</strong><br />{viewDateAndTime(data?.updatedAt) || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                </Box>
            </HStack>
        </Box>
    );
}
